<template>
    <v-autocomplete
        v-if          = "items"
        :items        = "items"
        item-value    = "id"
        item-text     = "text"
        :label        = "label"
        v-model       = "value"
        @change       = "onChange"
        :hide-details = "hideDetails"
        :readonly     = "readonly"
        :clearable    = "clearable"
    />
</template>

<script>
export default {
    name: "VYearSelect",

    props: {
        value: {
            required: true
        },
        label: {
            type: String,
            required: true,
        },
        from: {
            type: Number,
            required: true,
        },
        to: {
            type: Number,
            required: false,
            default: function () {
                return null;
            }
        },
        hideDetails: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        readonly: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        clearable: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        items: false,
    }),

    created() {
        let from = this.from;
        let to   = this.to ? this.to : new Date().getFullYear();

        this.items = [];
        while (from <= to) {
            this.items.push({
                id  : from,
                text: from
            })

            from ++;
        }
    },

    methods: {
        onChange () {
            this.$emit('input', this.value);
        }
    }
}
</script>

<style scoped>

</style>